import React from "reactn";
import appHook from "../../../../hooks/appHook";
import PropTypes from "prop-types";

// components
import Input from "../../../_common/form/input/Input";
import FormGroup from "../../../_common/form/form_group/FormGroup";
import InputGroup from "../../../_common/form/input_group/InputGroup";
import Label from "../../../_common/form/label/Label";
import Error from "../../../_common/error/Error";

// styled components
import PageText from "../../../_common/pageText/PageText.styled";
import UserInfoStyled from "./UserInfoStyled";
import SideContainer from "../../../_common/containers/SideContainer";

const UserInfoForm = props => {
    const { handleChange, handleKeyup, values, errors, title, handleBlur } = props;
    const { handleFocus, focus } = appHook();
    return (
        <UserInfoStyled>
            {title && <PageText className="hide-mobile">{title}</PageText>}
            <div className="flex--space-between">
                {/* First Name Field  */}
                <SideContainer>
                    <FormGroup error={errors.firstname} focused={focus === "firstname" ? true : !!(false || values.firstname)} classes="form__group">
                        <InputGroup>
                            <Label htmlFor="firstname" text="First name" />
                            <Input
                                id="firstname"
                                type="text"
                                name="firstname"
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values.firstname || ""}
                                required
                            />
                        </InputGroup>
                        {errors.firstname && <Error error={errors.firstname} />}
                    </FormGroup>
                </SideContainer>
                {/* Last Name Field  */}
                <SideContainer>
                    <FormGroup error={errors.lastname} focused={focus === "lastname" ? true : !!(false || values.lastname)} classes="form__group" noTopMob>
                        <InputGroup>
                            <Label htmlFor="lastname" text="Last name" />
                            <Input id="lastname" type="text" name="lastname" change={handleChange} keyup={handleKeyup} focus={handleFocus} blur={handleBlur} value={values.lastname || ""} required />
                        </InputGroup>
                        {errors.lastname && <Error error={errors.lastname} />}
                    </FormGroup>
                </SideContainer>
            </div>
            {/* Collector Account Field  */}
            {!window.collectorsCorner && (
                <FormGroup error={errors.collectorsaccountno} focused={focus === "collectorsaccountno" ? true : !!(false || values.collectorsaccountno)} classes="form__group" noTop>
                    <InputGroup>
                        <Label htmlFor="collectorsaccountno" text="Collector Account Number" />
                        <Input
                            id="collectorsaccountno"
                            type="text"
                            name="collectorsaccountno"
                            change={handleChange}
                            keyup={handleKeyup}
                            focus={handleFocus}
                            blur={handleBlur}
                            value={values.collectorsaccountno || ""}
                            required
                        />
                    </InputGroup>
                    {errors.collectorsaccountno && <Error error={errors.collectorsaccountno} />}
                </FormGroup>
            )}

            {/* Email Address Field  */}
            <FormGroup error={errors.email} focused={focus === "email" ? true : !!(false || values.email)} noTop>
                <InputGroup>
                    <Label htmlFor="email" text="Email" />
                    <Input id="email" type="email" name="email" change={handleChange} keyup={handleKeyup} focus={handleFocus} blur={handleBlur} value={values.email || ""} required />
                </InputGroup>
                {errors.email && <Error error={errors.email} />}
            </FormGroup>

            {/* Phone Number Field  */}
            <FormGroup error={errors.phonenumber} focused={focus === "phonenumber" ? true : !!(false || values.phonenumber)}>
                <InputGroup>
                    <Label htmlFor="phonenumber" text="Phone Number" />
                    <Input id="phonenumber" type="text" name="phonenumber" change={handleChange} keyup={handleKeyup} focus={handleFocus} blur={handleBlur} value={values.phonenumber || ""} required />
                </InputGroup>
                {errors.phonenumber && <Error error={errors.phonenumber} />}
            </FormGroup>
        </UserInfoStyled>
    );
};

UserInfoForm.propTypes = {
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    title: PropTypes.string
};

export default UserInfoForm;
